import {
  EEventSearchType,
  EPostSearchType,
  IEventSearch,
  IFileSearch,
  IMemberSearch,
  IOrganizationSearch,
  IPostSearch,
} from './search-types';

export const SearchHelpers = {
  getPostUrl(hit: IPostSearch): string {
    const hasGroup = Boolean(
      hit.group?._id ||
        (hit as IPostSearch & { groupId?: string | null }).groupId
    );
    const fallbackUrl = hasGroup
      ? `/community/post/${hit.objectID}`
      : `/post/${hit.objectID}`;

    switch (hit.postType) {
      case EPostSearchType.BLOG:
        return `/blog/${hit.blog._id}`;
      case EPostSearchType.POLL:
        return `/poll/${hit.poll._id}`;
      case EPostSearchType.POST:
        return fallbackUrl;
      case EPostSearchType.QUESTION:
        return `/question/${hit.question._id}`;
      case EPostSearchType.ANSWER:
        return hit.answer?.question?._id
          ? `/question/${hit.answer.question._id}`
          : fallbackUrl;
      case EPostSearchType.COMMENT:
        if (
          !hit.post ||
          typeof hit.post !== 'object' ||
          !('type' in hit.post)
        ) {
          return fallbackUrl;
        }
        switch (hit.post.type) {
          case EPostSearchType.BLOG:
            return `/blog/${hit.post.blog._id}?comment=${hit.objectID}`;
          case EPostSearchType.POLL:
            return `/poll/${hit.post.poll._id}?comment=${hit.objectID}`;
          case EPostSearchType.POST: {
            const commentPostPath = hasGroup
              ? `/community/post/${hit.post._id}`
              : `/post/${hit.post._id}`;
            return `${commentPostPath}?comment=${hit.objectID}`;
          }
          case EPostSearchType.QUESTION:
            return `/question/${hit.post.question._id}?comment=${hit.objectID}`;
          case EPostSearchType.ANSWER:
            return `/question/${hit.post.answer.questionId}?comment=${hit.objectID}`;
          default:
            return fallbackUrl;
        }
    }

    return fallbackUrl;
  },
  getMemberUrl(hit: IMemberSearch): string {
    return hit.userId ? `/members/${hit.userId}` : `/members/${hit.objectID}`;
  },
  getEventUrl(hit: IEventSearch): string {
    const mappedUrl = {
      [EEventSearchType.CONFERENCE]: `/events/conferences/${hit.objectID}`,
      [EEventSearchType.SIMPLE]: `/events/${hit.objectID}`,
    }[hit.eventType];

    // AI search can return eventType values not present in legacy enum (e.g. "VIRTUAL").
    return mappedUrl || `/events/${hit.objectID}`;
  },
  getFileUrl(hit: IFileSearch): string {
    // Existing files uploaded to algolia do not have the group id appended, but do use the group scope.
    // Getting the id off the scope is a bit hacky though, so using it only as a backup
    const scopeTokens = Array.isArray(hit.scope)
      ? hit.scope
      : typeof hit.scope === 'string'
      ? [hit.scope]
      : [];
    const groupId = hit.groupId
      ? hit.groupId
      : scopeTokens
          .filter((item) => item.startsWith('group_'))
          .at(0)
          ?.split('_')
          .at(-1);
    if (groupId)
      return `/community/groups/${groupId}/resources?versionFileId=${hit.objectID}`;
    //TODO: when we implement comment navigation, this can point to it using the hit.originalCommentId
    return hit.originalPostId ? `/post/${hit.originalPostId}` : '/community';
  },
};
